import $ from 'jquery';

export default function () {

    $('.js-toggle-password').click(function togglePassword() {

        $(this).toggleClass("active");

        const input = $(".js-password").find('input[name="Password"]');
        const type = $(this).hasClass("active") ? "text" : "password";

        input.attr("type", type);

    });

}
